import {HttpHeaders, HttpParams} from "@angular/common/http";

export function getBackHost(sufix: string): string {
    const host = window.location.hostname;
    const port = window.location.port;
    const protocol = window.location.protocol;
    let url = `${protocol}//${host}`;
    if (port) {
        const devPort = '4200';
        const backPort = (port === devPort) ? '8087' : port;
        url = `${url}:${backPort}`;
    }
    return `${url}/enquadramento/api/v1/${sufix}`;
}

